/* eslint-disable */
export default {
  download: '下載',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
